import CardItem from "./CardItem";

const Menus = ({ menuItems, categoryId }) => {
  return (
    <CardItem data={menuItems} categoryId={categoryId} title={"Menu Items"} />
  );
};
export default Menus;
